/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.product__accordion__title[data-collapsible-trigger]');
    if (!trigger) return;

    e.preventDefault();
    // Stop the theme's bubble-phase handler from double-toggling
    e.stopImmediatePropagation();

    var id = trigger.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;

    var inner = panel.querySelector('[data-collapsible-content]');
    var expanded = trigger.classList.contains('is-expanded');
    var innerHeight = inner ? inner.offsetHeight : panel.scrollHeight;

    if (expanded) {
      // Close
      panel.style.height = innerHeight + 'px';
      requestAnimationFrame(function() {
        panel.style.height = '0';
        trigger.classList.remove('is-expanded');
        panel.classList.remove('is-expanded');
      });
      setTimeout(function() { panel.style.height = ''; }, 500);
    } else {
      // Open
      panel.style.height = '0';
      requestAnimationFrame(function() {
        panel.style.height = innerHeight + 'px';
        trigger.classList.add('is-expanded');
        panel.classList.add('is-expanded');
      });
      setTimeout(function() { panel.style.height = 'auto'; }, 500);
      // Keep sticky buy-button calculation in sync (matches theme's openItem)
      trigger.dispatchEvent(new CustomEvent('theme:form:sticky', {
        bubbles: true,
        detail: { element: 'accordion' }
      }));
    }
  }, true); // true = capture phase







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
